import { createAction, props } from '@ngrx/store';
import { CreateTagDto, TagDto, TagReferencesDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';

export const TAG_ACTIONS_TYPE = '@app/tag';

// Read list
export const readTags = createAction(`${TAG_ACTIONS_TYPE}/read`, (query?: PaginatedListQuery) => ({ query }));
export const readTagsSuccess = createAction(`${TAG_ACTIONS_TYPE}/read/success`, props<{ data: TagDto[]; total: number }>());
export const readTagsFailure = createAction(`${TAG_ACTIONS_TYPE}/read/failure`, props<{ error: unknown }>());

// Detail. Read by id for the form page; the list is not a substitute — a tag
// reached by URL may never have been listed.
export const readTag = createAction(`${TAG_ACTIONS_TYPE}/read-one`, props<{ tagId: number }>());
export const readTagSuccess = createAction(`${TAG_ACTIONS_TYPE}/read-one/success`, props<{ tag: TagDto }>());
export const readTagFailure = createAction(`${TAG_ACTIONS_TYPE}/read-one/failure`, props<{ error: unknown }>());

// Create
export const createTag = createAction(`${TAG_ACTIONS_TYPE}/create`, props<{ tag: CreateTagDto }>());
export const createTagSuccess = createAction(`${TAG_ACTIONS_TYPE}/create/success`, props<{ tag: TagDto }>());
export const createTagFailure = createAction(`${TAG_ACTIONS_TYPE}/create/failure`, props<{ error: unknown }>());

// Update
export const updateTag = createAction(`${TAG_ACTIONS_TYPE}/update`, props<{ tagId: number; tag: CreateTagDto }>());
export const updateTagSuccess = createAction(`${TAG_ACTIONS_TYPE}/update/success`, props<{ tag: TagDto }>());
export const updateTagFailure = createAction(`${TAG_ACTIONS_TYPE}/update/failure`, props<{ error: unknown }>());

// Delete. `confirm` is the second pass: the API answers 428 while the tag is
// still attached to exercises, and only a request that acknowledges it detaches
// them and deletes.
export const deleteTag = createAction(`${TAG_ACTIONS_TYPE}/delete`, props<{ tagId: number; confirm?: boolean }>());
export const deleteTagSuccess = createAction(`${TAG_ACTIONS_TYPE}/delete/success`, props<{ tagId: number }>());
export const deleteTagFailure = createAction(`${TAG_ACTIONS_TYPE}/delete/failure`, props<{ error: unknown }>());
// Restore. The tag comes back into the vocabulary; the exercises it used to be
// on do NOT get it back — deleting it removed those associations and nothing
// records what they were.
export const restoreTag = createAction(`${TAG_ACTIONS_TYPE}/restore`, props<{ tagId: number }>());
export const restoreTagSuccess = createAction(`${TAG_ACTIONS_TYPE}/restore/success`, props<{ tag: TagDto }>());
export const restoreTagFailure = createAction(`${TAG_ACTIONS_TYPE}/restore/failure`, props<{ error: unknown }>());

export const deleteTagRequiresConfirmation = createAction(
  `${TAG_ACTIONS_TYPE}/delete/requires-confirmation`,
  props<{ tagId: number; message: string; references: TagReferencesDto | null }>(),
);
